import React from 'react';
import PropTypes from 'prop-types';

import { useAssetImages } from '../../../hooks';
import HeroImageGallery from './HeroImageGalleryTall';


export default function HeroImageGalleryTallWithFetch({
    assetId,
    campsiteId,
    tourId,
    hasThumbnailStrip,
    title,
    partnerAgency,
    locationState,
    totalCampgrounds,
    totalActivities,
    totalPOI,
    className
}) {
    const { heroImage, galleryImages, status } = useAssetImages({ assetId, campsiteId, tourId });

    return (
        <HeroImageGallery
            heroImage={heroImage}
            galleryImages={galleryImages}
            status={status}
            hasThumbnailStrip={hasThumbnailStrip}
            title={title}
            partnerAgency={partnerAgency}
            locationState={locationState}
            totalCampgrounds={totalCampgrounds}
            totalActivities={totalActivities}
            totalPOI={totalPOI}
            className={className} />
    );
}

HeroImageGalleryTallWithFetch.propTypes = {
    /** The id of the campground/permit/ticket facility/gateway/POI that the
     * api will use to fetch the images.
     * Do not use the images prop if using this prop. */
    assetId: PropTypes.string,

    /** The id of the campsite that the api will use to fetch the images
     * Do not use the images prop if using this prop.
    */
    campsiteId: PropTypes.string,

    /** The tour id the api will use to fetch the images
     * Do not use the images prop if using this prop.
    */
    tourId: PropTypes.string,

    /** Shows the thumbnail strip at the bottom of the open gallery */
    hasThumbnailStrip: PropTypes.bool,

    /** Title of the page/hero image */
    title: PropTypes.string,

    /**  Managing government agency */
    partnerAgency:PropTypes.oneOf(['BEP', 'BLM', 'DOI', 'DOT', 'NPS', 'NOAA', 'Smithsonian', 'TRE', 'TVA', 'USACE', 'USFS', 'USFWS']),
    
    /** The state where this inventory is located */
    locationState: PropTypes.string,
    
    /** Total number of campgrounds */
    totalCampgrounds: PropTypes.number,
    
    /** Total number of activities */
    totalActivities: PropTypes.number,
    
    /** Total number of POI */
    totalPOI:PropTypes.number,

    /** Additional className added to the outer container */
    className: PropTypes.string
};
HeroImageGalleryTallWithFetch.defaultProps = {
    hasThumbnailStrip: true
};
